import React from "react"
import "./Buttons.css"

// component for the cancel (white) button
// will accept any props including additional className, event listeners, etc
// insert the button's label as a child element to the component

function CancelButton({ className, type, ...props }) {
  return (
    <button
      {...props}
      className={
        "btn btn-block secondary-button-no-margin-hover btn-c button-component" +
        (className ? " " + className : "")
      }
      type={type || "button"}
    />
  )
}

export default CancelButton
